import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { SupervisorTypeEnum } from 'src/app/models/enums/supervisor-type.enum';

@Directive({
  selector: '[visible-for-temporary-supervisor-type]',
  standalone: false
})
export class VisibleForTemporarySupervisorTypeDirective implements OnInit {
  private el = inject(ElementRef);

  @Input('visible-for-temporary-supervisor-type') supervisorTypeId: number;

  constructor() { }

  ngOnInit(): void {
    if (this.supervisorTypeId !== SupervisorTypeEnum.Temporary) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
